import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import classNames from "classnames";

import * as c from "./competitorPageHeader.module.scss";
import { processMarkdown } from "@utils/markdown";
import { ContentfulCta } from "@components/shared/cta";
import StaticGradient from "@components/shared/staticGradient";
import PageHeaderWaveBackground from "@components/shared/waveBackground";

export const CompetitorPageHeader = ({ pageHeaderData = {} }) => {
  const { label, heading, subheading, cta, ctaSecondary, desktopImage, mobileImage } = pageHeaderData;

  const subheadingText = subheading?.subheading;
  const hasCtas = cta || ctaSecondary;
  return (
    <div className={c.background}>
      <StaticGradient
        opacity="0.45"
        top="-100px"
        mask="linear-gradient(to bottom, #000 0%, transparent 100%)"
        height="50%"
      />

      <section className={c.container}>
        <div className={c.competitorsPageRow}>
          <div className={c.header}>
            {label && <h1 className={classNames(c.eyebrow, "eyebrow")}>{label}</h1>}
            <h2 className={classNames(c.headline, "h1")} dangerouslySetInnerHTML={{ __html: heading }} />
            {subheadingText && (
              <p
                className={classNames(c.subheading, "p2")}
                dangerouslySetInnerHTML={{ __html: processMarkdown(subheadingText) }}
              />
            )}

            {hasCtas && (
              <div className={classNames(c.ctaContainer, ctaSecondary && c.ctaWrap)}>
                {cta && (
                  <ContentfulCta
                    {...cta}
                    style={cta.style?.[0] !== "Button Secondary" ? "Button Primary" : "Button Secondary"}
                  />
                )}
                {ctaSecondary && <ContentfulCta {...ctaSecondary} />}
              </div>
            )}
          </div>
          <div className={c.imageContainer}>
            {desktopImage && (
              <GatsbyImage
                image={getImage(desktopImage)}
                loading="eager"
                alt={label ? `${label} - Desktop image` : "Desktop image"}
              />
            )}
            {mobileImage && (
              <GatsbyImage
                image={getImage(mobileImage)}
                loading="eager"
                alt={label ? `${label} - Mobile image` : "Mobile image"}
              />
            )}
          </div>
        </div>
        <PageHeaderWaveBackground />
      </section>
    </div>
  );
};
